import { createGlobalStyle, css } from 'styled-components'
import { venture } from '../config'
import colorPalette from '@albatross/common-components/dist/themes/colorPalette'
import fonts from '@albatross/common-components/dist/themes/fonts'

import { ballyFonts } from './fontStyles'

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0px;
    font-family: Helvetica, Arial, sans-serif;
  }
  body, html {
    height:100%;
    width:100%;
  }
  ul,li {
    padding: 0;
    margin: 0;
  }

  body,
  button,
  input {
    -webkit-font-smoothing: antialiased;
  }
  *:focus {
    outline: none;
  }

  ${() =>
    venture === 'botemania_es' &&
    css`
    body {
      color: #333;
      font-family: Kumbh Sans, sans-serif;
    }

    /* hack for not breaking in smaller resolutions */
    @media (max-width: 345px) {
      th,
      td {
        padding: 6px;
      }
    }
    @media (min-width: 346px) and (max-width: 374px) {
      th,
      td {
        padding: 10px;
      }
    }
  `}

  ${() =>
    venture === 'jackpotjoy' &&
      css`
        body {
          font-family: Nunito Sans, sans-serif;
          color: #6e6f72;
        }
      }
  `}

${() =>
  venture === 'monopolycasino' &&
  css`
    body {
      font-family: ${fonts.monopolycasino.primary.name}, sans-serif;
      background: ${colorPalette.monopolycasino.content.background};
      color: ${colorPalette.monopolycasino.content.textColor};
      font-weight: 400;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    strong,
    b {
      text-transform: uppercase;
    }
  `}

  ${() =>
    venture === 'monopolycasino_es' &&
    css`    
      body {
        font-family: ${fonts.monopolycasino.primary.name}, sans-serif;
        font-weight: 400;
        background-color: ${colorPalette.monopolycasino_es.content.background};
        color: ${colorPalette.monopolycasino_es.content.textColor}
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      strong,
      b {
        text-transform: uppercase;
      }
  `}

  ${() =>
    venture === 'monopolycasinous' &&
    css`
      body {
        font-family: Outfit, sans-serif;
        color: #383838;
        font-weight: 400;
      }
  
      h1,
      h2,
      h3,
      h4,
      h5,
      strong,
      b {
        text-transform: uppercase;
      }
    `}
  ${() =>
    venture === 'monopolycasinoca' &&
    css`
      body {
        font-family: Outfit, sans-serif;
        color: #383838;
        font-weight: 400;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      strong,
      b {
        text-transform: uppercase;
      }
    `}  

  ${() =>
    venture === 'rainbowrichescasino' &&
      css`
        body {
          font-family: Arial, sans-serif;
        }
  `}

  ${() =>
    venture === 'virgingames' &&
    css`
      body {
        color: ${colorPalette.virgingames.secondary};
        font-family: font-family: Nunito Sans, sans-serif;
        font-weight: 400;
      }
  `}

  ${() =>
    venture === 'virgincasino' &&
    css`
      body {
        color: ${colorPalette.virgincasino.secondary};
        font-family: font-family: Nunito Sans, sans-serif;
        font-weight: 400;
      }
  `}

  ${() =>
    venture === 'doublebubblebingo' &&
    css`
      body {
        font-family: Kumbh Sans, sans-serif;
      }
  `}

  ${() =>
    venture === 'ballycasinonj' &&
    css`
      body {
        font-family: Nunito Sans, sans-serif;
      }

      ${ballyFonts}
  `}

  ${() =>
    venture === 'ballybetca' &&
    css`
      body {
        font-family: Nunito Sans, sans-serif;
      }

      ${ballyFonts}
  `}

  ${() =>
    venture === 'ballybetaz' &&
    css`
      body {
        font-family: BallyThrill-Regular, sans-serif;
      }

      ${ballyFonts}
  `}

  ${() =>
    venture === 'ballyuk' &&
    css`
      body {
        font-family: Nunito Sans, sans-serif;
      }
      
      ${ballyFonts}
  `}

  ${() =>
    venture === 'ballycasinogr' &&
    css`
      body {
        font-family: Nunito Sans, sans-serif;
      }
      
      ${ballyFonts}
  `}
`
